import { useMemo } from "react"
import { deps, rj, useRunRj } from "react-rocketjump"
import api from "../api"

const BusinessMonitorRj = rj({
  effectCaller: rj.configured(),
  effect: (wpAuth) => (filters) =>
    api.auth(wpAuth).get("/api/overview/business-monitor", filters),
})

export function useBusinessMonitor(fromDate, toDate, search, params) {
  const filters = useMemo(() => {
    if (fromDate && toDate) {
      return {
        ...params,
        from_date: fromDate,
        to_date: toDate,
        search: search,
      }
    } else {
      return null
    }
  }, [fromDate, params, search, toDate])

  return useRunRj(BusinessMonitorRj, [deps.maybe(filters)], false)
}
